import { useEffect } from 'react';
import { Box, Chip, Container, Divider, Typography } from '@mui/material';
import announcements from '../announcements';

const STORAGE_KEY = 'dismissedAnnouncement';

export default function WhatsNew() {
    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, announcements.current);
    }, []);

    return (
        <Container sx={{ mt: 5, width: '90%', pb: 12, maxWidth: 600 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                <Box
                    component="img"
                    src="/mangiamangia-icon.jpg"
                    alt="Mangia! Mangia!"
                    sx={{ width: 40, height: 40, borderRadius: 1, objectFit: 'cover', flexShrink: 0 }}
                />
                <Typography variant="h5" fontWeight={700}>What's New</Typography>
            </Box>

            {announcements.releases.map((release, i) => (
                <Box key={release.id}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography variant="h6" sx={{ fontWeight: 700 }}>{release.title}</Typography>
                                {i === 0 && <Chip label="Latest" size="small" color="primary" sx={{ height: 20, fontSize: 10 }} />}
                            </Box>
                            <Typography variant="caption" color="text.secondary">{release.date}</Typography>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
                        {release.features.map((f, j) => (
                            <Box key={j} sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                                <Box sx={{ fontSize: 28, lineHeight: 1, mt: 0.25, flexShrink: 0 }}>{f.icon}</Box>
                                <Box>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{f.title}</Typography>
                                    <Typography variant="body2" color="text.secondary">{f.description}</Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>

                    {i < announcements.releases.length - 1 && <Divider sx={{ mb: 3 }} />}
                </Box>
            ))}
        </Container>
    );
}
